// Central contact configuration for Ascend Tech Solutions.
// Update these constants in ONE place to change contact info site-wide.
export const CONTACT_INFO = {
  callNumberDisplay: "+91 96078 95009",
  callNumberIntl: "+919607895009",
  callHrefTel: "tel:+919607895009",

  whatsappNumberDisplay: "+91 80553 25009",
  whatsappNumberIntl: "918055325009",
  whatsappMessage:
    "Hello Ascend Tech Solutions, I visited your website and would like to know more about your recruitment services.",

  email: "hr@ascendtechsolution.com",
  emailHref: "mailto:hr@ascendtechsolution.com",

  location: "Pune, Maharashtra, India",
  hoursShort: "Mon – Sat · 9:30 AM – 6:30 PM",
};

export const whatsappHref = () =>
  `https://wa.me/${CONTACT_INFO.whatsappNumberIntl}?text=${encodeURIComponent(CONTACT_INFO.whatsappMessage)}`;
